import { gql } from '@apollo/client';

export const ADD_OR_UPDATE_DOCUMENT_SYNC_STATE = gql`
  mutation addOrUpdateDocumentSyncState($input: DocumentSyncStateInput) {
    addOrUpdateDocumentSyncState(input: $input) {
      commandId
    }
  }
`;

export const DELETE_DOCUMENT_SYNC_STATE = gql`
  mutation deleteDocumentSyncState($input: DeleteDocumentSyncStateInput) {
    deleteDocumentSyncState(input: $input) {
      commandId
    }
  }
`;
